import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { DeviceListResponse } from '../../../Interfaces/api/backoffice/device.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import { PagedResult } from '../../Shared/Interfaces/paged-result.interface';
import { Device } from '../../../Models/backoffice/device.model';
import { DeviceFilters } from '../Interfaces/device-filters.interface';

@Injectable({
  providedIn: 'root',
})
export class OrganizationDeviceService {
  private readonly _apiService = inject(ApiService);

  listRequest(
    organizationId: string,
    filters: DeviceFilters,
    page: number,
    pageSize: number,
  ): TypedResourceRequest<LaravelDefaultResponse<DeviceListResponse>> {
    return this._apiService.get<LaravelDefaultResponse<DeviceListResponse>>(
      endpoints.backoffice.organizationDevices(organizationId),
      { params: this._params(filters, page, pageSize), skipLoading: true, skipError: true },
    );
  }

  toPagedResult(
    response: LaravelDefaultResponse<DeviceListResponse> | undefined,
  ): PagedResult<Device> {
    const payload = response?.data;

    return {
      items: (payload?.devices ?? []).map((row) => new Device(row)),
      total: payload?.total ?? 0,
      page: payload?.page ?? 0,
      pageSize: payload?.pageSize ?? 0,
    };
  }

  toCounts(response: LaravelDefaultResponse<DeviceListResponse> | undefined): Record<string, number> {
    return response?.data?.counts ?? {};
  }

  private _params(
    filters: DeviceFilters,
    page: number,
    pageSize: number,
  ): Record<string, string | number> {
    const params: Record<string, string | number> = { page, pageSize };

    for (const [key, value] of Object.entries(filters)) {
      if (value !== '') {
        params[key] = String(value);
      }
    }

    return params;
  }
}
